(() => {
  const update = () => {
    const main = document.querySelector('product-info');
    const form = main?.querySelector('product-form form');
    const note = main?.querySelector('[data-bb-duo-note]');
    if (note && form) note.hidden = form.querySelector('[name="id"]')?.value !== '46928575692967';
    const rows = [...document.querySelectorAll('[id^="CartDrawer-Item-"], [id^="CartItem-"]')];
    const onlyBlossom = rows.length > 0 && rows.every(row => row.querySelector('a[href*="/products/"]')?.getAttribute('href').includes('/products/blossom-buds'));
    document.body.classList.toggle('bb-free-uk-cart', onlyBlossom && document.body.dataset.bbCountry === 'GB');
  };
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; update(); });
  };
  document.addEventListener('change', schedule);
  const observer = new MutationObserver(schedule);
  for (const cart of document.querySelectorAll('cart-drawer, cart-items')) observer.observe(cart, {childList:true,subtree:true});
  const product = document.querySelector('product-info');
  if (product) observer.observe(product, {childList:true,subtree:true});
  update();
})();

